import { createContext } from 'react';

export const TaskActionRunnerContext = createContext(null);

export const EMPTY_TASK_ACTION_SOURCE = [];
